"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _bowser = _interopRequireDefault(require("bowser"));
var _mobx = require("mobx");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _dimensions = _interopRequireDefault(require("./dimensions"));
var _constants = require("@seedlang/constants");
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var RootLayout = (_class = /*#__PURE__*/function () {
  function RootLayout(parent) {
    _classCallCheck(this, RootLayout);
    _initializerDefineProperty(this, "isSafari", _descriptor, this);
    _initializerDefineProperty(this, "nativeViewportWidth", _descriptor2, this);
    _initializerDefineProperty(this, "nativeViewportHeight", _descriptor3, this);
    _initializerDefineProperty(this, "hasNotch", _descriptor4, this);
    _initializerDefineProperty(this, "deviceOs", _descriptor5, this);
    _initializerDefineProperty(this, "deviceName", _descriptor6, this);
    _initializerDefineProperty(this, "browserName", _descriptor7, this);
    _initializerDefineProperty(this, "browserVersion", _descriptor8, this);
    _initializerDefineProperty(this, "statusBarHeight", _descriptor9, this);
    _initializerDefineProperty(this, "deviceType", _descriptor10, this);
    _initializerDefineProperty(this, "isNativeTablet", _descriptor11, this);
    _initializerDefineProperty(this, "keyboardHeight", _descriptor12, this);
    _initializerDefineProperty(this, "keyboardVisible", _descriptor13, this);
    _initializerDefineProperty(this, "deviceLanguageId", _descriptor14, this);
    _initializerDefineProperty(this, "osVersion", _descriptor15, this);
    _initializerDefineProperty(this, "topInsetHeight", _descriptor16, this);
    _initializerDefineProperty(this, "bottomInsetHeight", _descriptor17, this);
    _initializerDefineProperty(this, "systemDarkMode", _descriptor18, this);
    _initializerDefineProperty(this, "userDarkMode", _descriptor19, this);
    this.parent = parent;
    this.isSafari = _bowser["default"].safari;
    this.browserName = _bowser["default"].name;
    this.browserVersion = _bowser["default"].version;
    this.isFirefox = _bowser["default"].firefox;
    this.isChrome = _bowser["default"].chrome;
    if (!this.isNative) {
      _dimensions["default"].addListeners();
    }
  }
  return _createClass(RootLayout, [{
    key: "setDeviceLanguageId",
    value: function setDeviceLanguageId(deviceLanguageId) {
      this.deviceLanguageId = deviceLanguageId;
    }
  }, {
    key: "setNativeDimensions",
    value: function setNativeDimensions(width, height) {
      if (width) {
        this.nativeViewportWidth = width;
        this.nativeViewportHeight = height;
      }
    }
  }, {
    key: "setInsetHeight",
    value: function setInsetHeight(topInsetHeight, bottomInsetHeight) {
      this.topInsetHeight = topInsetHeight;
      this.bottomInsetHeight = bottomInsetHeight;
    }
  }, {
    key: "setKeyboardHeight",
    value: function setKeyboardHeight(keyboardHeight) {
      this.keyboardHeight = keyboardHeight;
    }
  }, {
    key: "setKeyboardVisible",
    value: function setKeyboardVisible(keyboardVisible) {
      this.keyboardVisible = keyboardVisible;
    }
  }, {
    key: "setNativeDevice",
    value: function setNativeDevice(deviceOs) {
      this.deviceOs = deviceOs;
    }
  }, {
    key: "setOsVersion",
    value: function setOsVersion(osVersion) {
      this.osVersion = osVersion;
    }
  }, {
    key: "setDeviceType",
    value: function setDeviceType(deviceType) {
      this.deviceType = deviceType;
    }
  }, {
    key: "setSystemDarkMode",
    value: function setSystemDarkMode(systemDarkMode) {
      this.systemDarkMode = systemDarkMode;
    }
  }, {
    key: "setUserDarkMode",
    value: function setUserDarkMode(userDarkMode) {
      this.userDarkMode = userDarkMode;
    }
  }, {
    key: "darkMode",
    get: function get() {
      return !this.userDarkMode || this.userDarkMode === 'system' ? this.systemDarkMode : this.userDarkMode === 'dark';
    }
  }, {
    key: "backgroundColor",
    get: function get() {
      return this.darkMode ? '#333' : '#fff';
    }
  }, {
    key: "secondaryBackgroundColor",
    get: function get() {
      return this.darkMode ? '#666' : '#E6E6E6';
    }
  }, {
    key: "textColor",
    get: function get() {
      return this.darkMode ? '#FFF' : '#1A1A1A';
    }
  }, {
    key: "secondaryTextColor",
    get: function get() {
      return this.darkMode ? '#B3B3B3' : '#333';
    }
  }, {
    key: "modalBackgroundColor",
    get: function get() {
      return this.darkMode ? '#333' : 'whitesmoke';
    }
  }, {
    key: "faintOffsetColor",
    get: function get() {
      return this.darkMode ? '#474747' : '#E6E6E6';
    }
  }, {
    key: "userInputColor",
    get: function get() {
      return this.darkMode ? '#666' : '#FFF';
    }
  }, {
    key: "lightGreyColor",
    get: function get() {
      return '#E6E6E6';
    }
  }, {
    key: "disabledColor",
    get: function get() {
      return this.darkMode ? '#777' : _constants.Theme.disabled;
    }
  }, {
    key: "darkGreyColor",
    get: function get() {
      return '#333';
    }
  }, {
    key: "viewportHeight",
    get: function get() {
      return this.isNative ? this.nativeViewportHeight : _dimensions["default"].viewportHeight;
    }
  }, {
    key: "viewportWidth",
    get: function get() {
      return this.isNative ? this.nativeViewportWidth : _dimensions["default"].viewportWidth;
    }
  }, {
    key: "mediaRecorderSupported",
    get: function get() {
      return this.isNative || (_bowser["default"].chrome || _bowser["default"].firefox) && !_bowser["default"].ios;
    }
  }, {
    key: "hasRightColumn",
    get: function get() {
      return !this.isMobile && this.viewportWidth > 800;
    }
  }, {
    key: "defaultModalWidth",
    get: function get() {
      return Math.min(400, this.viewportWidth - 40);
    }
  }, {
    key: "leftColumnWidth",
    get: function get() {
      var container = Math.min(1160, this.viewportWidth);
      if (this.hasRightColumn) {
        return container - 300;
      }
      return container;
    }
  }, {
    key: "rightColumnWidth",
    get: function get() {
      return this.viewportWidth >= 800 ? _constants.Layout.HOME_RIGHT_COLUMN_WIDTH : 0;
    }
  }, {
    key: "minimumHeight",
    get: function get() {
      return this.viewportHeight < 699;
    }
  }, {
    key: "setIsNativeTablet",
    value: function setIsNativeTablet(isNativeTablet) {
      this.isNativeTablet = isNativeTablet;
    }
  }, {
    key: "isAndroid",
    get: function get() {
      return this.deviceOs === 'android';
    }
  }, {
    key: "isIos",
    get: function get() {
      return this.deviceOs === 'ios';
    }
  }, {
    key: "osName",
    get: function get() {
      if (_bowser["default"].mac) {
        return 'Mac';
      }
      if (_bowser["default"].windows) {
        return 'Windows';
      }
      if (_bowser["default"].android) {
        return 'Android';
      }
      if (_bowser["default"].ios) {
        return 'iOS';
      }
      if (_bowser["default"].linux) {
        return 'Linux';
      }
      if (_bowser["default"].chromeos) {
        return 'ChromeOS';
      }
      return 'Unknown OS';
    }
  }, {
    key: "ios",
    get: function get() {
      return _bowser["default"].ios;
    }
  }, {
    key: "hasNativeMenuBar",
    get: function get() {
      return this.isAndroid && this.bottomInsetHeight > 47;
    }
  }, {
    key: "viewportHeightWithoutKeyboard",
    get: function get() {
      var keyboardHeight = this.keyboardHeight || 0;
      return this.viewportHeight - keyboardHeight - 80;
    }
  }, {
    key: "iPadSafari",
    get: function get() {
      return this.ios && this.isSafari && _bowser["default"].iosdevice === 'ipad';
    }
  }, {
    key: "device",
    get: function get() {
      if (this.isAndroid) {
        return 'android';
      } else if (this.isIos) {
        return 'ios';
      }
      return 'web';
    }
  }, {
    key: "isNative",
    get: function get() {
      return navigator.product === 'ReactNative';
    }
  }, {
    key: "isMobile",
    get: function get() {
      return !this.isNative && (_bowser["default"].mobile || this.viewportWidth < 700);
    }
  }, {
    key: "isDesktop",
    get: function get() {
      return !this.isNative && !this.isMobile;
    }
  }, {
    key: "updateDimensions",
    value: function updateDimensions() {
      _dimensions["default"].updateDimensions();
    }
  }]);
}(), _descriptor = _applyDecoratedDescriptor(_class.prototype, "isSafari", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "nativeViewportWidth", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "nativeViewportHeight", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "hasNotch", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "deviceOs", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "deviceName", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "browserName", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "browserVersion", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "statusBarHeight", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "deviceType", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "isNativeTablet", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "keyboardHeight", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "keyboardVisible", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "deviceLanguageId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "osVersion", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "topInsetHeight", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "bottomInsetHeight", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "systemDarkMode", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "userDarkMode", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "setDeviceLanguageId", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setDeviceLanguageId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setNativeDimensions", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setNativeDimensions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setInsetHeight", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setInsetHeight"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setKeyboardHeight", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setKeyboardHeight"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setKeyboardVisible", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setKeyboardVisible"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setNativeDevice", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setNativeDevice"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setOsVersion", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setOsVersion"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setDeviceType", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setDeviceType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setSystemDarkMode", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setSystemDarkMode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setUserDarkMode", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setUserDarkMode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "darkMode", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "darkMode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "backgroundColor", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "backgroundColor"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "secondaryBackgroundColor", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "secondaryBackgroundColor"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "textColor", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "textColor"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "secondaryTextColor", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "secondaryTextColor"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "modalBackgroundColor", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "modalBackgroundColor"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "faintOffsetColor", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "faintOffsetColor"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userInputColor", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userInputColor"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "lightGreyColor", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "lightGreyColor"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "disabledColor", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "disabledColor"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "darkGreyColor", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "darkGreyColor"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "viewportHeight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "viewportHeight"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "viewportWidth", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "viewportWidth"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "mediaRecorderSupported", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "mediaRecorderSupported"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasRightColumn", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasRightColumn"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "defaultModalWidth", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "defaultModalWidth"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "leftColumnWidth", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "leftColumnWidth"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "rightColumnWidth", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "rightColumnWidth"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "minimumHeight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "minimumHeight"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setIsNativeTablet", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setIsNativeTablet"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isAndroid", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isAndroid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isIos", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isIos"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "osName", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "osName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "ios", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "ios"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasNativeMenuBar", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasNativeMenuBar"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "viewportHeightWithoutKeyboard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "viewportHeightWithoutKeyboard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "iPadSafari", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "iPadSafari"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "device", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "device"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isNative", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isNative"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isMobile", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isMobile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDesktop", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isDesktop"), _class.prototype), _class);
var _default = exports["default"] = RootLayout;